import {globalStore} from '../../main.js'

export default {
  name: 'changePassword',
  data() {
    return {
      formSubmitted: false,
      success: false,
      PasswordConfirm: null,
      changePasswordError: false,
      startPasswordCheck: false,
      errorAfterRequest: null,
      credentials: {
        UserName: null,
        OldPassword: null,
        Password: null
      }
    }
  },
created: function () {
    this.credentials.UserName = this.$route.query.username;
    document.title = this.labels.MMID_CHANGE_PASSWORD;
  },
  beforeDestroy: function(){
    document.title = globalStore.defaultTitle;;
  },
  methods: {
    changePassword: function () {
      this.startPasswordCheck = true;
      this.formSubmitted = true;

      var model = {
        UserName: this.credentials.UserName,
        Password: this.credentials.OldPassword,
        NewPassword: this.credentials.Password
      };

      if (this.formValid) {
        this.$axios.post(globalStore.host + 'ChangeUserPassword', model)
          .then(response => {
            if (response.status === 200) {

              if(response.data == 'Ok'){
                this.success = true;
                this.changePasswordError = false;
                this.errorAfterRequest = null;

                var self = this;
                setTimeout(function () {
                  self.redirectToBack();
                }, 1000);

              } else if(response.data == 'InvalidPassword'){
                this.changePasswordError = false;
                this.errorAfterRequest = this.labels.INVALID_OLD_PASSWORD;
              } else if(response.data == 'UserNotFoundOrInactive'){
                this.changePasswordError = false;
                this.errorAfterRequest = this.labels.USER_NOT_FOUND_OR_INACTIVE;
              } else{
                this.changePasswordError = true;
              }

            }
          })
          .catch(err => {
            console.log(err);
            this.changePasswordError = true;
            if (err.response.status === 404) {
              this.errorAfterRequest = this.labels.USER_NOT_FOUND_OR_INACTIVE;
            }
            return err;
          });
      }
    },
    cancel: function () {
      this.redirectToBack();
    },
    redirectToBack: function () {
	  var backLink = this.$route.query.backurl;
      if (!!backLink && globalStore.isBackLinkAllowed(backLink)) {
        backLink = backLink.indexOf('http') < 0 ? 'http://' + backLink : backLink;
      } else {
        backLink = globalStore.digiUrl;
      }     
      window.location.href = backLink;
    }
  },
  computed: {
    passwordConfirmValid: function () {
      return this.credentials.Password === this.PasswordConfirm;
    },
    passwordFilled: function () {
      return !!this.credentials.Password;
    },
    oldPasswordFilled: function () {
      return !!this.credentials.OldPassword;
    },
    passwordIsStrong: function () {
      return this.isLong && this.isLowercase && this.isUppercase && this.isNumber && this.isSpecial;
    },
    formValid: function () {
      return this.formSubmitted && this.passwordFilled && this.oldPasswordFilled && this.passwordConfirmValid && this.passwordIsStrong;
    },
    isLong: function () {
      return this.credentials.Password != null && this.credentials.Password.length >= 10;
    },
    isLowercase: function () {
      return this.credentials.Password != null && new RegExp("^(?=.*[a-z])").test(this.credentials.Password);
    },
    isUppercase: function () {
      return this.credentials.Password != null && new RegExp("^(?=.*[A-Z])").test(this.credentials.Password);
    },
    isNumber: function () {
      return this.credentials.Password != null && new RegExp("^(?=.*[0-9])").test(this.credentials.Password);
    },
    isSpecial: function () {
      return this.credentials.Password != null && new RegExp("^(?=.*[!_@#\$%\^&*\'\"§%&/()=?`*+.:,;<>°^\-])").test(this.credentials.Password);
    },
    labels: function() {
        return globalStore.culture.strings.CreatePassword;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/ChangePassword/ChangePassword.js